import { useDispatch } from "react-redux";
import ServiceMain from "../../../features/masters/service/components/service-main";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import { useEffect } from "react";

const title = "Master Service";

const ServiceMasterPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <ServiceMain />;
};

export default ServiceMasterPage;
